module.exports = __webpack_public_path__ + "img/jz.2a2576d0.png";